import MessageClient from "./MessageClient";
import { Constants } from "../../constants/constants";

const SystemSettingService = {
    getBySettingCode: async (settingCode: any) => {
        const result = await MessageClient().get(
            `${Constants.ApiPath.SYSTEM_SETTING.GET_BY_SETTING_CODE}/${settingCode}`
        );
        return result.data.result;
    },

    update: async (data: any) => {
        const result = await MessageClient().post(Constants.ApiPath.SYSTEM_SETTING.UPDATE, data);
        return result.data;
    },
};

export default SystemSettingService;
